import {
    DataGrid, Column, Pager, Paging, GroupPanel, Sorting, FilterRow, ColumnChooser, Export,
    Scrolling,
} from 'devextreme-react/data-grid';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { DateBox, SelectBox, Toast } from 'devextreme-react';
import { FilterDescriptor } from 'devextreme/data';

import { reatiler } from '@/core/utils/report-datas';
import reportService from '@/projects/platform/services/report-service';
import lookupService from '@/projects/platform/services/lookup-service';
import DataSource from 'devextreme/data/data_source';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import { extFormatDate } from '@/core/helper/date-helper';

var store = new DataSource({});

function isNotEmpty(value: any) {
    return value !== undefined && value !== null && value !== '';
}

function getDataSource(filter: any) {

    store = new DataSource({
        filter: filter,
        load(loadOptions: any) {
            console.log(loadOptions)
            let params = '?';
            [
                'skip',
                'take',
            ].forEach((i) => {
                if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
            });
            if (loadOptions.filter) {
                loadOptions.filter.forEach((item: any) => {
                    params += `${item[0]}=${item[2]}&`
                });

            }
            params = params.slice(0, -1);
            return reportService.getSalesPerformanceReportFour(params)
                .then((response) => ({
                    data: response.data.searchResult,
                    totalCount: response.data.totalCount,
                }))
                .catch(() => { throw new Error('Data Loading Error'); });
        },
    });
}
var filter: Array<FilterDescriptor> = [];

export default function SalesPerformanceGridReportReportFour() {

    const [startDate, setStartDate] = useState<Date>(new Date(2024, 0, 1))
    const [endDate, setEndDate] = useState<Date>(new Date())
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: 'info',
        message: '',
    });

    const [productGroups, setProductGroups] = useState<any>([]);
    function getColumnNameProps(column: any) {
        let columnProps = {
            value: null,
            columnName: '',
        };
        switch (column.fullName) {
            case "columns[0].visible":
                columnProps.columnName = 'groupByretailer';
                columnProps.value = column.value;
                break;
            case "columns[1].visible":
                columnProps.columnName = 'groupByProductGroup';
                columnProps.value = column.value;
                break;
            case "columns[2].visible":
                columnProps.columnName = 'groupBySubProductGroup';
                columnProps.value = column.value;
                break;
            case "columns[3].visible":
                columnProps.columnName = 'groupByProduct';
                columnProps.value = column.value;
                break;
            case "columns[4].visible":
                columnProps.columnName = 'groupByProvince';
                columnProps.value = column.value;
                break;
            case "columns[5].visible":
                columnProps.columnName = 'groupByStore';
                columnProps.value = column.value;
                break;
            default:
                columnProps.columnName = 'unknown';
                break;
        }
        return columnProps;
    }
    function onSelectByClickValueChanged(e: any) {

        let columnProps = getColumnNameProps(e);
        if (columnProps.columnName === 'unknown')
            return;
        if (columnProps.value == true) {
            addToFilterArray(filter, columnProps.columnName, '=', columnProps.value ?? undefined);
        }
        else if (columnProps.value == false) {
            addToFilterArray(filter, columnProps.columnName, '=', columnProps.value ?? undefined);
        }
        else {
            addToFilterArray(filter, columnProps.columnName, '=', undefined);
        }
        store.filter(filter);
        store.load();
    }

    function addToFilterArray(filter: any, key: any, operator: any, value: any) {
        const existingIndex = filter.findIndex((item: any) => item[0] === key);
        if (existingIndex !== -1) {
            filter.splice(existingIndex, 1);
        }
        if (value != undefined)
            filter.push([key, operator, value]);

    }

    function onSubProductValueChanged(e: any) {
        addToFilterArray(filter, 'productGroup', '=', e.value ?? undefined);
        store.filter(filter);
        store.load();
    }

    function onRetailerValueChanged(e: any) {
        addToFilterArray(filter, 'retailerId', '=', e.value ?? undefined);
        store.filter(filter);
        store.load();
    }
    function onStartDateValueChanged(e: any) {

        setStartDate(e.value);
        addToFilterArray(filter, 'startDate', '=', extFormatDate(e.value));
        store.filter(filter);
        store.load();
    }
    function onEndDateValueChanged(e: any) {

        setEndDate(e.value);

        addToFilterArray(filter, 'endDate', '=', extFormatDate(e.value));
        store.filter(filter);
        store.load();
    }
    function getProductGroups() {

        return lookupService.getProductGroupLookup({})
            .then((response) => (
                setProductGroups(response.data)
            ))
            .catch(() => { throw new Error('Data Loading Error'); });
    }
    function getDefaultFilterValues() {

        addToFilterArray(filter, 'startDate', '=', extFormatDate(startDate));
        addToFilterArray(filter, 'endDate', '=', extFormatDate(endDate));
        addToFilterArray(filter, 'groupByProvince', '=', false);
        addToFilterArray(filter, 'groupByStore', '=', false);
        return filter;
    }

    function formatCurrency(arg: any) {
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(arg.value);
    }

    function onExporting(e: any) {

        var diff = Math.abs(startDate.getTime() - endDate.getTime());
        var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        if (diffDays <= 60) {
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Customizable_Sales_Report.xlsx');
                });
            });
        }
        else {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'info',
                message: 'Excel"e aktarmak için en fazla 60 günlük bir periyod seçebilirsiniz.'
            });
        }
    }

    function onHiding() {
        setToastConfig({
            ...toastConfig,
            isVisible: false,
        })
    }


    useState(() => {
        const defaultFilterValues = getDefaultFilterValues();
        getProductGroups();
        getDataSource(defaultFilterValues);
    })

    const allowedPageSizes = [10, 15, 20, 25, 50, 100, 200];
    return (
        <>
            <Row>
                <h5 className="text-center m-10"> Customizable Sales Report</h5>
            </Row>
            <br></br>
            <Row>
                <Toast
                    visible={toastConfig.isVisible}
                    message={toastConfig.message}
                    type='info'
                    onHiding={onHiding}
                    displayTime={1000}
                />
                <Col md={1}></Col>
                <Col md={2}>
                    <Form.Label htmlFor="productGroups">Product Group</Form.Label>
                    <SelectBox
                        name='productGroups'
                        showClearButton={true}
                        dataSource={productGroups}
                        // defaultValue={productGroups[0].Value}
                        valueExpr="value"
                        displayExpr="text"
                        onValueChanged={onSubProductValueChanged}
                    />
                </Col>
                <Col md={2}>
                    <Form.Label htmlFor="retailers">Retailers</Form.Label>
                    <SelectBox
                        name='retailers'
                        showClearButton={true}
                        dataSource={reatiler}
                        // defaultValue={reatiler[0].Value}
                        valueExpr="Value"
                        displayExpr="Text"
                        onValueChanged={onRetailerValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="startDate">Start Date</Form.Label>
                    <DateBox
                        value={startDate}
                        name='startDate'
                        type="date"
                        onValueChanged={onStartDateValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="endDate">End Date</Form.Label>
                    <DateBox
                        value={endDate}
                        name='endDate'
                        type="date"
                        onValueChanged={onEndDateValueChanged}
                    />
                </Col>
                <Col md={1}></Col>
            </Row>
            <br></br>
                    <DataGrid
                        cacheEnabled={false}
                        className={'dx-card wide-card'}
                        dataSource={store}
                        showBorders={true}
                showColumnLines={false}
                        columnAutoWidth={true}
                        columnHidingEnabled={false}
                        remoteOperations={true}
                        onOptionChanged={onSelectByClickValueChanged}
                        onExporting={onExporting}

                    >
                        <Scrolling columnRenderingMode='virtual'  />
                        <ColumnChooser enabled />
                        <Export enabled allowExportSelectedData />
                        
                        <Column dataField="retailer" caption="Retailer" name='Retailer' />
                        <Column dataField="productGroup" caption="Product Group" name='ProductGroup' />
                        <Column dataField="subProductGroup" caption="Sub Product Group" name='SubProductGroup' />
                        <Column dataField="product" caption="Product" name='Product' />
                        <Column dataField="province" caption="Province" name='Province' visible={false} />
                        <Column dataField="store" caption="Store" name='Store' visible={false} />
                        <Column dataField="salesAmount" caption="Sales Amount" name='Sales Amount' customizeText={formatCurrency} showInColumnChooser={false} />
                        <Column dataField="salesQuantity" caption="Sales Quantity" name='Sales Quantity' showInColumnChooser={false} />
                        <Column dataField="salesAvgAmount" caption="Sales Avg Amount" name='Sales Avg Amount' customizeText={formatCurrency} showInColumnChooser={false} />
                        <Paging defaultPageSize={10} />
                        <Pager
                    showNavigationButtons={true} 
            visible={true}
                            showInfo={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes} />
                    </DataGrid>
            <Row>
                <Col md={1}></Col>
                <Col md={10}>
                </Col>
                <Col md={1}></Col>
            </Row >
        </>
    );
}
